import { Box, Skeleton } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import React, { useEffect } from "react"
import { useInView } from "react-intersection-observer"
import { CloudImage } from "../../CloudProviderTypes"
import CloudImageBrowserImage from "../../common/browser/CloudImageBrowserImage"
import CloudImageBrowserImageBroken from "../../common/browser/CloudImageBrowserImageBroken"
import { useVNZImage } from "../hooks/useVNZImage"
import { useVNZImageActions } from "../hooks/useVNZImageActions"

interface Props {
  image: CloudImage
  onImageSelect: (id: EntityId) => void
  isSelected: boolean
}

const VNZImageSelector: React.FC<Props> = ({
  image,
  onImageSelect,
  isSelected,
}) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    initialInView: false,
  })

  const { vnzImage } = useVNZImage(image.id)
  const { isLoadingThumbnail, hasLoadedThumbnail, hasErrorLoadingThumbnail } =
    vnzImage || {}
  const canShowImage = hasLoadedThumbnail

  const shouldLoadThumbnail =
    inView &&
    vnzImage &&
    !hasLoadedThumbnail &&
    !isLoadingThumbnail &&
    !hasErrorLoadingThumbnail

  const { loadVNZImageThumbnail } = useVNZImageActions()

  useEffect(() => {
    if (shouldLoadThumbnail) {
      loadVNZImageThumbnail(vnzImage)
    }
  }, [shouldLoadThumbnail, loadVNZImageThumbnail, vnzImage])

  if (hasErrorLoadingThumbnail) {
    return <CloudImageBrowserImageBroken />
  }

  return (
    <Box position="relative" height="165px" ref={ref}>
      {canShowImage && (
        <CloudImageBrowserImage
          image={image}
          isSelected={isSelected}
          onImageSelect={() => onImageSelect(image.id)}
        />
      )}
      {!canShowImage && (
        <Skeleton width="100%" height="100%" borderRadius="8px" />
      )}
    </Box>
  )
}

export default VNZImageSelector
